import autosize from "autosize";

export default function (Alpine) {
  Alpine.magic("updateAutosize", function (element) {
    return () => autosize.update(element);
  });
}
